import { Injectable } from '@angular/core';
import { HttpService } from '../service/http.service';
import { AuditUpdate } from '../audit-update';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AuditUpdateService {

  constructor(
    private httpService: HttpService
  ) { }

  toUpdateString(audit: AuditUpdate){
    if(audit.databaseTableName.id == 2){
      if(audit.databaseOperationType.id == 1){
        return "New update has been made for " + audit.schoolName + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } else if(audit.databaseOperationType.id == 2){
        return "Update has been modified for " + audit.schoolName + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } else if(audit.databaseOperationType.id == 3){
        return "Update has been deleted for " + audit.schoolName + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      }
    } else if(audit.databaseTableName.id == 3){
      if(audit.databaseOperationType.id == 1){
        return "New email template has been made for " + audit.emailTemplateName + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } else if(audit.databaseOperationType.id == 2){
        return "Email template has been modified for " + audit.emailTemplateName + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } else if(audit.databaseOperationType.id == 3){
        return "Email template has been deleted for " + audit.emailTemplateName + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } 
    } else if(audit.databaseTableName.id == 4){
      if(audit.databaseOperationType.id == 1){
        return "New Call memo has been made for " + audit.name + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } else if(audit.databaseOperationType.id == 2){
        return "Call memo has been modified for " + audit.name + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } else if(audit.databaseOperationType.id == 3){
        return "Call memo has been deleted for " + audit.name + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } 
    }
    else if(audit.databaseTableName.id == 5){
      if(audit.databaseOperationType.id == 1){
        return "New Update has been made for " + audit.name + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } else if(audit.databaseOperationType.id == 2){
        return "Update has been modified for " + audit.name + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } else if(audit.databaseOperationType.id == 3){
        return "Update has been deleted for " + audit.name + " by " + this.capitalizeFirstLetter(audit.encodedBy.name!)
        + " at " + moment(audit.created).format("DD/MM/YYYY HH:mm:ss");
      } 
    } 
    return "no message";

  }

  capitalizeFirstLetter(str: string){
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
